//@ts-nocheck

window.bot = undefined
window.THREE = undefined
window.localServer = undefined
window.worldView = undefined
window.viewer = undefined
window.loadedData = undefined
